<template>
  <section>
    <div>
      <v-card flat>
        <v-card flat>
          <router-link to="/Orders" style="text-decoration: none">
            <v-icon>mdi-keyboard-backspace</v-icon>
            <span class="px-2 index-head"> Sales / Orders</span>
          </router-link>
        </v-card>
        <div class="mt-5">
          <v-row>
            <v-col cols="12" md="6">
              <h1 class="heading-1">Archived</h1>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end align-center">
                <!-- <v-btn color="primary" depressed class="px-4 py-5">
                  Delete All
                </v-btn> -->
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <v-row class="mt-4">
        <v-col cols="8" md="6">
          <v-card flat style="color: #f2f3f9">
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              @input="fetchData"
            >
            </v-text-field>
          </v-card>
        </v-col>
      </v-row>

      <v-card class="mt-3" outlined>
        <v-data-table
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="GetSales.list"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage()"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ index }">
            <b class="index_index_text">
              {{ index + itemsPerPage * (page - 1) + 1 }}
            </b>
          </template>

          <template v-slot:[`item.order`]="{ item }">
            <b class="index_index_text"> {{ item.OrderCode }} </b>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <span class="index_index_text">
              {{ item.Items[0]?.OrderDate?.split("T")[0] }}
            </span>
          </template>
          <template v-slot:[`item.client`]="{ item }">
            <span class="index_head_text">
              {{
                item.Items[0].IsUser
                  ? item.Items[0].User.FirstName +
                    " " +
                    item.Items[0].User.LastName
                  : "Guest User"
              }}
            </span>
          </template>

          <template v-slot:[`item.payment`]="{ item }">
            <span class="index_head_text">
              {{ item.Items[0]?.Payment?.PaymentType === 1 ? "Card" : item.Items[0]?.Payment?.PaymentType === 2 ? "Paypal" : "Offline" }}
            </span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span class="index_head_text">
              {{ item.Items[0]?.Payment?.Price }}
            </span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              class="px-10"
              text-color="#06A23B"
              style="background: rgba(227, 243, 233, 1)"
            >
              {{
                item.Items[0].Status === 2
                  ? "NEW"
                  : item.Items[0].Status === 3
                  ? "RECEIVED"
                  : item.Items[0].Status === 4
                  ? "SHIPPED"
                  : item.Items[0].Status === 5
                  ? "INVOICED"
                  : "VOID"
              }}
            </v-chip>
            <!-- <span class="index_head_text"> {{ item.status}} </span> -->
          </template>
          <!-- <template v-slot:[`item.TrackingId`]="{ item }">
            <div class="pt-8">
              <v-text-field
                v-model="item.Items[0].TrackingId"
                dense
                readonly
                outlined
              ></v-text-field>
            </div>
          </template> -->
          <template v-slot:[`item.actions`]="{ item }">
            <!-- <v-icon small class="mr-2" @click="moreMenu(item)">
            mdi-dots-vertical
          </v-icon> -->

            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat >
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="setArchiveDialogue(item.OrderCode)"
                  >
                    <!-- @click="restoredialog = true" -->
                    <v-icon color="#646464">mdi-history</v-icon>
                    <span class="ml-4 text_style">UNARCHIVE</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                        depressed
                        color="transparent"
                        block
                        class="d-flex justify-start"
                        @click="dialog = true;orderCode=item.OrderCode"
                      >
                        <v-icon color="#646464">mdi-delete</v-icon>
                        <span class="ml-4 text_style">Delete</span>
                      </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="setItemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>

    <v-dialog v-model="dialog" persistent max-width="290">
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          color="transparent"
          block
          class="d-flex justify-start"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="#646464">mdi-delete</v-icon>
          <span class="ml-4 text_style">Delete</span>
        </v-btn>
      </template> -->
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="btnloader"
            @click="deleteItem()"
          >
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="restoredialog" persistent max-width="620">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <span class="heading-2"></span>
          <v-icon @click="restoredialog = false">mdi-close</v-icon>
        </div>
        <div class="pa-5 text-center font-weight-bold">
          <span class="text-h6">
            Do you want to add this back to active Sales?
          </span>
        </div>
        <div class="d-flex justify-center gap-3 pb-10">
          <div>
            <v-btn
              color="primary"
              class="px-9"
              :disabled="btnloader"
              @click="archieveStatus()"
            >
              <span v-if="btnloader != true">Yes</span>
              <v-progress-circular
                indeterminate
                v-else
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div>
          <v-btn
            color="primary"
            class="px-9"
            outlined
            @click="archieveDialogue = false"
          >
            No
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
    orderCode:null,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10 || "",
      selectedOrderCode: null,
      infodialog: false,
      SeeProfileDialog: false,
      invoicesDialog: false,
      restoredialog: false,
      dialog: false,
      btnloader: false,
      deldialog: false,
      infodetailsdialog: false,
      tableLoader: false,
      search: "",

      headers: [
        { text: "#", value: "index" },
        { text: "Order No", value: "order" },
        { text: "Date Placed", value: "date" },
        { text: "Client", value: "client" },
        { text: "Payment Type", value: "payment" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "status" },
        // { text: "Tracking #", value: "TrackingId" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [
        {
          index: 123,
          order: "12345",
          date: "12/12/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
          waybill: "KJSDF938592NS",
        },
        {
          index: 123,
          order: "12345",
          date: "12/14/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          waybill: "KJSDF938592NS",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          waybill: "KJSDF938592NS",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
          waybill: "KJSDF938592NS",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "03/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "01/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "12/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
        {
          index: 123,
          order: "12345",
          date: "03/15/2021",
          client: "Michelle Valentino",
          store: "US",
          payment: "Cheque",
          amount: "$150",
          status: "New",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["GetSales"]),
  },
  mounted() {
    this.fetchDataAllOrders()
  },
  methods: {
    fetchDataAllOrders(){
      this.tableLoader = true;
    this.$store.dispatch("GetAllOrder", { IsArchieve: true }).then(() => {
      this.tableLoader = false;
    });
    },
    deleteItem(){
      this.btnloader = true
      const obj = {
        orderCode:this.orderCode
      }
      this.$store.dispatch("DeleteStoreCartItem",obj).then(()=>{
        this.btnloader = false
        this.dialog = false
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Delete Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          this.fetchDataAllOrders()
      })
    },
    goBack() {
      this.isHidden = false;
    },
    setArchiveDialogue(orderCode) {
      this.selectedOrderCode = orderCode;
      this.restoredialog = true;
    },
    archieveStatus() {
      this.btnloader=true;
      let ordercode = this.selectedOrderCode;

      if (!ordercode) {
        console.error("No OrderCode Found");
        return;
      }

      this.$store
        .dispatch("ChnageArchieveStatus", { ordercode })
        .then((archieveResponse) => {
          if (archieveResponse.Status) {
            return this.$store.dispatch("GetAllOrder", { IsArchieve: true });
          }
        })
        .then(() => {
          this.btnloader=false;
          this.restoredialog = false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "UnArchieved Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    displayedItemsPerPage() {
      if (this.itemsPerPage === "All") {
        return (this.GetSales.length);
      } else {
        return this.itemsPerPage;
      }
    },
    setItemsPerPage(e) {
      this.tableLoader = true;
      this.search = "";
      if (e === "All") {
        let pageNumber = -1;
        let pageSize = 10000;
        this.$store
          .dispatch("GetAllOrder", { pageNumber, pageSize, IsArchieve: true })
          .then(() => {
            this.tableLoader = false;
          });
      } else {
        let pageSize = parseInt(e);
        this.$store
          .dispatch("GetAllOrder", { pageSize, IsArchieve: true })
          .then(() => {
            this.tableLoader = false;
          });
      }
      //  2024-01-16
      this.calculatePageCount();
    },
    calculatePageCount() {
      if (this.itemsPerPage === "All") {
        this.pageCount = 1;
      } else {
        this.pageCount = Math.ceil(this.GetSales.Total / this.itemsPerPage);
      }
    },
    fetchData() {
      this.tableLoader = true;
      const payload = {
        pageSize: this.itemsPerPage,
        OrderCode: this.selectedOrderCode,
        IsArchieve: true,
      };
      this.$store.dispatch("GetAllOrder", payload).then(() => {
        this.tableLoader = false;
      });
    },
  },
};
</script>
<style scoped>
.font-48 {
  font-family: "Noto Serif";
  font-weight: 700;
  font-size: 30px;
  line-height: 54.48px;
  color: rgba(34, 34, 34, 1);
}
.index_index_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  color: #222222;
}
.index_head_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  color: #222222;
}
.index-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: rgba(34, 34, 34, 0.7);
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
